<template>
  <transition name="fade">
    <box v-show="show" v-if="msgIndex < 3" style="width:60vw;height: 50vh">
      <template v-slot:body>
        <!-- <img src="@/assets/lin-2.png" class="box-lin" /> -->
        <img src="@/assets/straight.gif" class="box-lin" />
        <div class="main">
          <p class="main-header">{{ message[msgIndex] }}</p>
        </div>
        <div class="bottom">
          <p class="underline"></p>
          <action action-class="yellow" text="請點我" @goNext="goNext">
            <template v-slot:icon>
              <font-awesome-icon :icon="['fas', 'caret-right']" size="lg" />
            </template>
          </action>
        </div>
      </template>
    </box>
  </transition>
</template>
<script>
import Box from "@/components/Box";
import Action from "@/components/Action.vue";

export default {
  components: { Box, Action },
  data() {
    return {
      show: false,
      msgIndex: 0,
      message: [
        "我從鄉下來到臺北，白天在UPT航空公司打工，晚上在補習班上課，冀望一朝一日能成為UPT的正式職員，那真是出人頭地的一天。",
        "鄉下的阿爹寫信來，要我寄兩萬塊回家給二兄作結婚用，我的存款只有幾千元，怎向阿爹交代？",
        "阿爹來限時信，寫著他後日頭搭頭班火車上台北，要我到車站接他……經理不讓我請假，阿爹你在車站等我一下……"
      ]
    };
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 300);
  },
  methods: {
    goNext() {
      console.log(this.msgIndex)
      if (this.msgIndex <= 2) this.msgIndex++;
      if (this.msgIndex > 2) {

        this.$router.push("novel");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  margin-top: 3em;
  padding-left: 8em;

  .main-header {
    width: 80%;
    word-wrap: break-word;
    margin-top: 1.2em;
    font-size: 1.5em;
    font-weight: bold;
    color: #965151;
    text-align: justify;
  }
}
.underline {
  width: 250px;
  margin-right: 20px;
  font-size: 2em;
  font-weight: bold;
  color: #965151;
  white-space: pre;
  display: inline-block;
  border: 3px solid transparent;
  border-width: 0 0 3px 0;
  border-image: linear-gradient(
    90deg,
    #965151 50%,
    rgba(150, 81, 81, 0.0224164) 104.35%,
    rgba(150, 81, 81, 0) 105.59%
  );
  border-image-slice: 1;
}
.bottom {
  margin-top: 2.5em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.box-lin {
  position: absolute;
  bottom: -8em;
  right: -4em;
  height: 18vw;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
